import { useQuery } from '@tanstack/react-query'
import NumbersService from 'api/NumbersService'
import { SortDirection } from 'utils/constants'
import { metricsKeys } from 'utils/queries/metrics'

export const useGetDataPointsByMetricId = (
  {
    metricId,
    sortDirection = SortDirection.ASC,
    isSystemMetric = false,
  }: {
    metricId: string
    sortDirection?: SortDirection
    isSystemMetric?: boolean
  },
  queryOptions = {}
) => {
  return useQuery(
    metricsKeys.getDataPoints(metricId),
    async () => {
      const dataPoints = await NumbersService.getDataPoints({
        metricId,
        sortDirection,
        isSystemMetric,
      })
      return dataPoints
    },
    {
      staleTime: 20 * 1000,
      ...queryOptions,
    }
  )
}

export const useCalculatedDataPointsByMetricId = (
  {
    metricId,
    subjectId,
  }: {
    metricId: string
    subjectId: string
  },
  queryOptions = {}
) => {
  return useQuery(
    metricsKeys.getDataPoints(metricId),
    async () => {
      const dataPoints = await NumbersService.calculateDataPoints({
        metricId,
        subjectId,
      })
      return dataPoints
    },
    {
      staleTime: 20 * 1000,
      ...queryOptions,
    }
  )
}
